// extracted by mini-css-extract-plugin
export default {"NavigationWrapper":"JuryShell_NavigationWrapper__IDNbK","NavMenu":"JuryShell_NavMenu__rqgXL","NavItem":"JuryShell_NavItem__EECuB","NavItemActive":"JuryShell_NavItemActive__W73bX"};